import { connect} from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";
import { IconButton, AvatarGroup, Tooltip, Avatar } from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import axios from "axios";
import StatusLayout from "components/Status";
import AttachmentManager from "./AttachmentManager";
import CommentManager from "./CommentManager";
import { PriorityHigh } from "@mui/icons-material";
import { errorToast } from "helpers/Notification";
import { getError } from "store/helpers/common_functions";
import { successToast } from "helpers/Notification";


function TaskManagement({ location, SetSelectedMenu, loggedUser, systemSettings, PutAction }) {
    const mainBackground = systemSettings?.mainBackground;

    const [open, setOpen] = React.useState(0);
    const [value, setValue] = React.useState({});
    const [list, setList] = React.useState([]);
    const [id, setId] = React.useState();
    const [count, setCount] = React.useState(0);
    const [selected, setSelected] = React.useState(location.state?.status ?? "all");
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [options, setOptions] = useState([]);
    const [attachmentOpen, setAttachmentOpen] = React.useState(false);
    const [task, setTask] = React.useState();
    const [commentOpen, setCommentOpen] = React.useState(false);


    const history = useHistory();

    useEffect(() => {
        setSelected(location.state?.status ?? "all");
    }, [location.state]);


    useEffect(() => {
        SetSelectedMenu({
            menu: "my_initiation",
            title: "Initiated by me"
        })
    }, []);

    const allTheMeetings = async () => {
        const data = await axios.get('api/meeting/?status=completed');
        setOptions(data.data.meeting);
    }
    useEffect(() => {
        allTheMeetings()
    },
        []
    );


    const columns = [
        {
            name: "name",
            label: "Name",
        },
        {
            name: "startDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "endDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: 'task_assignees',
            label: 'Assigned to',
            options: {
                customBodyRender: (value, tableMeta) => {
                    const rowData = tableMeta.rowData;
                    const task_assignees = rowData[4];
                    const downloadUrl = "your_download_url";

                    if (!task_assignees || task_assignees.length === 0) {
                        return "Unassigned";
                    }

                    // Check if the logged-in user is one of the assignees
                    const isMeAssigned = task_assignees.some(
                        (assignee) => assignee.Resource.id === loggedUser?.Resource?.id
                    );

                    if (task_assignees.length === 1) {
                        const assigneeName = task_assignees[0].Resource.names;
                        return isMeAssigned ? "Me" : assigneeName;
                    }

                    if (task_assignees.length === 2) {
                        const assigneeNames = task_assignees.map((assignee) =>
                            assignee.Resource.id === loggedUser?.Resource?.id ? "Me" : assignee.Resource.names
                        );

                        return (
                            <Tooltip
                                title={
                                    <div>
                                        {assigneeNames.map((name, index) => (
                                            <div key={index}>{name}</div>
                                        ))}
                                    </div>
                                }
                                arrow={true}
                            >
                                <div className={'flex flex-start'}>
                                    <AvatarGroup
                                        sx={{
                                            display: 'inline-flex',
                                            '& .MuiAvatar-root': {
                                                width: 24,
                                                height: 24,
                                                fontSize: 12
                                            }
                                        }}
                                    >
                                        {task_assignees.map((assignee) => (
                                            <Avatar
                                                key={assignee.Resource.names}
                                                alt={assignee.Resource.names}
                                                src={assignee.Resource.profile ? `${downloadUrl}/${assignee.Resource.profile}` : undefined}
                                                sx={{ width: 24, height: 24 }}
                                            />
                                        ))}
                                    </AvatarGroup>
                                </div>
                            </Tooltip>
                        );
                    }

                    if (task_assignees.length > 2) {
                        const assigneeNames = task_assignees.map((assignee) =>
                            assignee.Resource.id === loggedUser?.Resource?.id ? "Me" : assignee.Resource.names
                        );

                        return (
                            <Tooltip
                                title={
                                    <div>
                                        {assigneeNames.map((name, index) => (
                                            <div key={index}>{name}</div>
                                        ))}
                                    </div>
                                }
                                arrow={true}
                            >
                                <AvatarGroup
                                    total={task_assignees.length}
                                    sx={{
                                        display: 'inline-flex',
                                        '& .MuiAvatar-root': {
                                            width: 24,
                                            height: 24,
                                            fontSize: 12
                                        }
                                    }}
                                >
                                    <Avatar
                                        alt={task_assignees[0].Resource.names}
                                        src={task_assignees[0].Resource.profile ? `${downloadUrl}/${task_assignees[0].Resource.profile}` : undefined}
                                        sx={{ width: 24, height: 24 }}
                                    />
                                    <Avatar
                                        alt={task_assignees[1].Resource.names}
                                        src={task_assignees[1].Resource.profile ? `${downloadUrl}/${task_assignees[1].Resource.profile}` : undefined}
                                        sx={{ width: 24, height: 24 }}
                                    />
                                </AvatarGroup>
                            </Tooltip>
                        );
                    }
                },
            }
        },
        {
            name: 'id',
            label: 'Comments',
            options: {
                customBodyRender: (value, tableMeta) => {
                    const currentTask = list && list?.length && list?.find(v => v.id === value);

                    return <div className="flex flex-row gap-4 ">
                        {currentTask?.task_comments?.length > 0 && <Tooltip onClick={
                            () => { }
                        }
                            onMouseOver={
                                (e) => {
                                    e.stopPropagation();
                                    e.target.style.cursor = "pointer";
                                }
                            }
                        >
                            <div className="relative flex items-center">
                                <span
                                    style={{
                                        top: "-6px",
                                        right: "-7px",
                                        padding: "2px",
                                        fontSize: "10px",
                                        backgroundColor:mainBackground,
                                    }}
                                    className="absolute  bg-red-600 text-white rounded-full font-bold flex items-center justify-center">
                                    {currentTask.task_comments.length}
                                </span>
                                <i className="fas fa-comment text-blueGray-500 text-lg"></i>
                            </div>
                        </Tooltip>
                        }

                    </div>
                }
            }
        },

        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    let color =
                        status === "completed"
                            ? "success"
                            : status === "canceled"
                                ? "error"
                                : status === "pending review"
                                    ? "text-green-500"
                                    : status === "under review"
                                        ? "bg-secondary"
                                        : status === "missing information"
                                            ? "bg-black-500"
                                            : status === "forwarded"
                                                ? "bg-primary"
                                                : "info";
                    return (
                        <span
                            style={{ fontSize: "0.85rem" }}
                        >
                            <StatusLayout status={status} />
                        </span>

                    );
                },
            },
        },

        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => (
                    <div className="flex items-center">

                        <IconButton onClick={() => {
                            history.push(`/admin/task/${v}`);
                        }}>
                            <img
                                src={require("../../assets/icons/eye.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm text-blueGray-300"
                                }
                            />
                        </IconButton>
                        <IconButton 

                            onClick={(e) => {
                                e.stopPropagation();
                                setOpen(2);
                                const obj = list.find(vx => vx.id === v);
                                setId(v);
                                setValue0('name', obj.name);
                                // setValue0('startDate', moment(obj.startDate).format("YYYY-MM-DD HH:mm"));
                                // setValue0('endDate', moment(obj.endDate).format("YYYY-MM-DD HH:mm"));

                                setValue0( "startDate", obj.startDate ? moment(obj.startDate).utc().format("YYYY-MM-DDTHH:mm") : "" );
                                setValue0( "endDate", obj.endDate  ? moment(obj.endDate).utc().format("YYYY-MM-DDTHH:mm") : "" );
                                setValue0('description', obj.description);
                            
                        }}>
                            <img
                                src={require("../../assets/icons/pencil.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm "

                                }/>
                        </IconButton>

                        <IconButton onClick={(e) => { 
                            e.stopPropagation();
                            setId(v); setDeleteOpen(true) }}>
                            <img
                                src={require("../../assets/icons/trash.svg").default}
                                alt="Decorative SVG"
                                className={
                                    " mr-2 text-sm "
                                }
                            />
                        </IconButton>

                    </div>
                ),
            },
        },
        {
             name: "isUrgent",
             label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta) => {
                        const rowData = tableMeta.rowData;
                        const isUrgent = rowData[8];
                        if (isUrgent) {
                            return (
                                <Tooltip title="This task is marked as urgent">

                           <span
                                style={{
                                    backgroundColor: '#f44336',
                                    color: '#fff',
                                    padding: '2px 8px',
                                    borderRadius: '12px',
                                    fontSize: '0.75rem',
                                }}
                                >
                                    Urgent
                                </span>
                                </Tooltip>
                            );
                        } else {
                            return (
                                <Tooltip title="Mark as urgent">
                                    <IconButton
                                        onClick={async (e) => {
                                            e.stopPropagation();
                                            const response = await PutAction(`/api/task/change-urgency/${rowData[5]}`, { isUrgent: true });
                                            if (!response.status) {
                                                errorToast(getError(response));
                                                return;
                                            }
                                            successToast(response?.data.message || "Task marked as urgent successfully By Admin");
                                            setCount(v => v + 1);
                                        }}
                                    >
                                        <PriorityHigh color="disabled" />
                                    </IconButton>
                                </Tooltip>
                            );
                            }
                        }
                    }
        }


    ];
    const setValue0 = (name, val) => {
        if (!name) {
            return null;
        }

        setValue(v => {
            v[name] = val;
            return { ...v };
        });
    }
    const onSuccess = () => setCount(v => v + 1);


    return <div className="w-full mb-12 px-4">
        <DeleteDialog open={deleteOpen} setOpen={() => setDeleteOpen(false)} onSuccess={onSuccess} url={`/api/task/delete/${id}`} />
            
        <AttachmentManager taskId={id} task={task} openAttachment={attachmentOpen}  onClose={
                () => {
                    setAttachmentOpen(false);
                }
            }
            onSuccess={onSuccess}
            />

     <CommentManager taskId={id} task={task} open={commentOpen} setOpen={() => setCommentOpen(false)} onClose={
                () => {
                    setCommentOpen(false);
                }
            }
            onSuccess={onSuccess}
          />

        <FormDialog maxWidth={'md'} col={6} open={open > 0} 
         onSuccess={() => {
          onSuccess();
        }}
         setOpen={setOpen} url={open === 1 ? '/api/task/create' : `/api/task/update/${id}`} title={open === 1 ? "Create New Task" : "Edit Task"} 
        fields={[
            {
                name: "name",
                label: "Task name",
                value: value['name'],
                required: true,
                col: 12,
                setValue: (val) => setValue0('name', val),
            },
            {
                name: "startDate",
                label: "Start Date",
                // type: "date",
                type: 'datetime-local',
                value: value['startDate'],
                required: true,
                setValue: (val) => setValue0('startDate', val),
            },
            {
                name: "endDate",
                label: "End Date",
                // type: "date",
                type: 'datetime-local',
                value: value['endDate'],
                required: true,
                setValue: (val) => setValue0('endDate', val),
                validate: (v) => value['startDate'] && moment(v).isBefore(value['startDate']) ? "Start date can't  be after end date" : true
            },
            {
                name: "meetingId",
                label: "Orginated From",
                value: value['meetingId'],
                required: false,
                type: 'select',
                values: options && options.map((v) => {
                    return { value: v.id, label: v.name }
                }),
                col: 12,
                setValue: (val) => setValue0('meetingId', val),

            },
            {
                name: "description",
                label: "Task Description",
                value: value['description'],
                required: false,
                type: 'textarea',
                rows: 5,
                col: 12,
                setValue: (val) => setValue0("description", val),

            },

        ]}
         />
        <DatatableComponent 
        order={location.state?.order}
        search={false}
        viewColumns={false}
        searchfield={true}

            onRowClick={(data, { rowIndex }) => {
                history.push(`/admin/task/${list[rowIndex].id}`);
            }} 
            onAddNew={() => setOpen(1)} processData={(data) => {
                setList(data.data);
                return data;
            }} elevation={1} 
            columns={columns}
             url={`/api/task/list/notRelated?status=${selected}&count=${count}`} 
             title={`Task Management(Not related to project) ${location.state?.status ? `(Status : ${location.state?.status})` : ''}`} />
    </div>;
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskManagement);
